<template>
  <body class="body">
    <TrustWecobi />
    <ProductOverviewBuyers />
    <ProductOverviewBrands />
    <Footer />
  </body>
</template>

<script>
import TrustWecobi from "./ProductOverviewSection/TrustWecobi.vue";
import ProductOverviewBuyers from "./ProductOverviewSection/ProductOverviewBuyers.vue";
import ProductOverviewBrands from "./ProductOverviewSection/ProductOverviewBrands.vue";
import Footer from "../SharedComponents/Footer.vue";

export default {
  name: "ProductOverviewSection",
  components: {
    TrustWecobi,
    ProductOverviewBuyers,
    ProductOverviewBrands,
    Footer,
  },
};
</script>

<style scoped>
.body {
  display: flex;
  flex-direction: column;
  gap: 24px;
  background-color: #000000;
  margin-top: 58px;
  padding: 0px 35px;
  z-index: 0;
}
@media (max-width: 744px) {
  .body {
    padding: 0px 16px;
  }
}
</style>
